import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { stateToHTML } from "draft-js-export-html";
export function fromRaw(raw) {
  if (raw) {
    try {
      let content = JSON.parse(raw);
      return EditorState.createWithContent(convertFromRaw(content));
    } catch {
      /**
       * this is needed for legacy reasons:
       * old text was saved as a text, not as a HTML,
       * this is why we need to convert it into an EditorState compatible
       * format.
       */
      let content = {
        blocks: [
          {
            key: "d4idd", // do not ask me what this is for
            text: raw,
            type: "unstyled",
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {},
          },
        ],
        entityMap: {},
      };
      return EditorState.createWithContent(convertFromRaw(content));
    }
  }
}

export function toHTML(editorState) {
  if (editorState) {
    return draftToHtml(convertToRaw(editorState.getCurrentContent()));
  }

  // simply return an empty div tag if no editorState is provided
  return "<div></div>";
}

export function htmlTag(html) {
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}

// combine all things lol
// this is so bad
export function renderHtmlFromRaw(raw) {
  return htmlTag(toHTML(fromRaw(raw)));
}

export function isEmptyHTML(raw) {
  if (!raw) return true;

  try {
    let content = JSON.parse(raw);
    return content.blocks[0].text === "";
  } catch {
    if (raw && raw === "") return true;
    return false;
  }
}

export function renderQuillHtml(content) {
  if (!content) return <div></div>;

  let html = content;

  try {
    // Try to parse JSON
    const parsed = JSON.parse(content);

    // If it looks like Draft.js raw content, convert → HTML
    if (parsed.blocks && parsed.entityMap !== undefined) {
      const contentState = convertFromRaw(parsed);
      html = stateToHTML(contentState);
    }
  } catch (e) {
    // Not JSON → keep content as-is (already HTML from ReactQuill)
  }

  return (
    <div
      className="quill-content ql-editor"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

// Helper function to check if a string is HTML (for Quill content)
export function isHtml(str) {
  if (!str || typeof str !== 'string') return false;
  return /<[a-z][\s\S]*>/i.test(str);
}
